import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LanguageLoader } from "../../assets/languages";
import { ConvertNumbers, decodeHtmlEntities } from "../utils";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import FieldContainer from "./FieldContainer";
import { useLocation } from 'react-router-dom';
import Attachments from "./Attachments";
import Phone from "./Phone";
import Email from "./Email";
import Lineitem from "./Lineitem";
import Relate from "./Relate.jsx";
import Addresses from "./Addresses.jsx";
import Tree from "./Tree.jsx";
import { SetSettings } from "../../redux/actions/settings.js";
import { FetchDropdownAPI } from "../../services/index.js";
import FormatValue from "./FormatValues";
import Dropdown from "./Dropdown.jsx";

const Fields = ({module, field, Callback, value, error, related_to, subpanel, customization}) =>
{
	value = decodeHtmlEntities(value);
	const dispatch = useDispatch();
	const settings = useSelector((state) => state.settings);
	const preferences = useSelector((state) => state.preferences);
	const location = useLocation();
	const language = LanguageLoader(preferences.language);
	const fieldDefs = settings.definitions[subpanel ? 'subpanels' : 'modules'][module];
	const accessible = customization && customization.accessible ? true : false;
	const [inputValue, SetInputValue] = useState(value || '');
    
	useEffect(() => 
	{
		SetInputValue(value || '');
		// eslint-disable-next-line
	}, [value]);

	useEffect(() =>
	{		
		if (value && value.length > 0)
		{
			LogicFields(field, value);
		}
	// eslint-disable-next-line
	}, [value]);

	
	const LogicFields = async (field, value) =>
	{
		let returnValue = value;
		switch (field)
		{
			case 'industry':
				const data1 ={ 
					type : 'industry',
					key : value
				}
				const APIResponse = await FetchDropdownAPI(data1);
				if(APIResponse.length)
				{
					const fields = settings.definitions.modules[module].fields;
					const subindustryOptions = APIResponse.reduce((result, item) => {
						result[item.id] = item.name;
						return result;
					}, {});
					fields['subindustry'].options = subindustryOptions;
					dispatch(SetSettings({...settings, fields}));
				}
				break;
			case 'pipeline' :
				let stageName = '';
				switch (module)
				{
					case 'Opportunities': stageName = 'sales_stage'; break;
					case 'AOS_Contracts': stageName = 'contract_stage'; break;
					default: break;
				}
				const fields = settings.definitions.modules[module].fields;
				if(fields[stageName] && fields[stageName].options)
				{
					const data2 = {
						type : 'pipeline',
						key : value
					};
					const saleStageOptions = await FetchDropdownAPI(data2);
					fields[stageName].options = saleStageOptions;
					dispatch(SetSettings({...settings, fields}));
				}
				break;
			default : returnValue = value;
		}
		return returnValue;
	}

	if(!module || !fieldDefs || !fieldDefs['fields'][field])
	{
		return null;
	}
	const vardef = fieldDefs['fields'][field];
	const label = (typeof vardef.label === 'object') ? vardef.label[preferences.language] : vardef.label;
	let element;
	let classes = customization && customization.className ? customization.className : null;
	let hideLabel = customization && customization.hideLabel ? customization.hideLabel : false;

	const onChangeHandler = (changedValue) =>
	{
		let filteredValue = changedValue;
		if (vardef.type === 'int') 
		{
			filteredValue = changedValue.replace(/[^0-9]/g, '');
		}
		// For enum/multienum fields, convert "0" (blank option) to undefined
		// This ensures blank selections don't send "0" to the API
		else if ((vardef.type === 'enum' || vardef.type === 'multienum') && changedValue !== undefined && changedValue !== null)
		{
			if (vardef.type === 'multienum' && Array.isArray(changedValue))
			{
				// Filter out "0" values from multi-select arrays
				filteredValue = changedValue.filter(v => v !== "0" && v !== 0);
				// Return undefined if array is empty after filtering
				filteredValue = filteredValue.length > 0 ? filteredValue : undefined;
			}
			else if (changedValue === "0" || changedValue === 0)
			{
				filteredValue = undefined;
			}
		}
		SetInputValue(filteredValue);
		LogicFields(field, filteredValue);
		if(Callback)
		{
			Callback(filteredValue);
		}
	}

	let access = vardef.access;
	if((location.pathname.indexOf('/detail/') > -1 || location.pathname.indexOf('/subpanel/') > -1) && access !== 'disabled')
	{
		access = 'readonly';
	}
	if(access === 'disabled')
	{
		return null;
	}
	else if(access === 'readonly' && !accessible)
	{
		element = <div className='value'><FormatValue value={value} vardef={vardef} format={true} related_to={related_to}/></div>
		if(vardef.type === 'lineitems' || (field === 'description' && module === 'Knowledge_Base'))
		{
			classes = 'w-full';
			hideLabel = true;
		}
	}
	else if(vardef.type === 'enum' || vardef.type === 'multienum')
	{
		element = <Dropdown defaultValue={value} onChange={(value) => onChangeHandler(value)} multiple={vardef.type === 'multienum' || (customization && customization.multiple)} options={vardef.options} disabled={vardef.disabled}/>
	}
	else if(vardef.type === 'date' || vardef.type === 'datetime')
	{
		let plugins = [];
		let format = 'YYYY/MM/DD';
		if(vardef.type === 'datetime')
		{
			format = 'YYYY/MM/DD HH:mm';
			plugins.push(<TimePicker position="bottom"/>);
		}
		element = <DatePicker onChange={(e) => onChangeHandler(e ? ConvertNumbers(e.format()) : '')}
			name={field}
			arrow={false}
			hideOnScroll
			value={value}
			inputClass="date-picker"
			containerClassName="w-full"
			calendar={preferences.language === 'en_US' ? null : persian}
			locale={preferences.language === 'en_US' ? null : persian_fa}
			calendarPosition="bottom-right"
			readOnly={vardef.disabled}
			format={format}
			plugins={plugins}/>
	}
	else if(vardef.type === 'bool' || vardef.type === 'radio')
	{
		element = <div className="form-check form-switch">
			<input onChange={(e) => onChangeHandler(e.target.value)} name={field} className="form-check-input mt-3" type="checkbox" disabled={field.disabled}/>
			{field.checkbox_label && language[module][field.checkbox_label] ? <label className="form-check-label mt-3">{language[module][field.checkbox_label]}</label> : null}
		</div>
	}
	else if(vardef.type === 'textarea' || vardef.type === 'text')
	{
		element = <textarea rows={1} className="!transition-none !delay-0" onChange={(e) => onChangeHandler(e.target.value)} disabled={vardef.disabled}></textarea>
	}
	else if(vardef.type === 'relate')
	{
		let defaultValue = {'id': value, 'name': related_to};
		element = <Relate vardef={vardef} onChange={(value) => onChangeHandler(value.id)} defaultValue={defaultValue}/>
	}
	else if(vardef.type === 'tree')
	{
		element = <Tree vardef={vardef} onChange={(value) => onChangeHandler(value)} defaultValue={value}/>
	}
	else if(vardef.type === 'numbers')
	{
		element = <Phone onChange={(values) => onChangeHandler(values)} defaultValue={value}/>
	}
	else if(vardef.type === 'emails')
	{
		element = <Email onChange={(values) => onChangeHandler(values)} defaultValue={value}/>
	}
	else if(vardef.type === 'attachments')
	{
		element = <Attachments types={vardef.options ? vardef.options : null} defaultValue={value} single={!vardef.multiple} onChange={(value) => onChangeHandler(value)}/>
	}
	else if(vardef.type === 'lineitems')
	{
		element = <Lineitem defaultValue={value} onChange={(value) => onChangeHandler(value)} />
		classes = 'w-full';
		hideLabel = true;
	}
	else if(vardef.type === 'addresses')
	{
		element = <Addresses onChange={(value) => onChangeHandler(value)} defaultValue={value}/>
	}
	else
	{
		element = <input onChange={(e) => onChangeHandler(e.target.value)} type="text" className="form-control" value={inputValue} disabled={vardef.disabled}/>
	}
	if(!element)
	{
		return null;
	}
	return <FieldContainer label={hideLabel ? null : label} error={error} className={classes} required={vardef.validation && vardef.validation.includes("required")}>{element}</FieldContainer>
}

export default Fields;